export default __webpack_public_path__ + "static/media/ChristineJones-1.315453b3.jpg";